module.exports = __webpack_public_path__ + "media/images/common/mypage_btn_ov-607c4b4a3c72a150c5b1fe6e4bf045a4.gif";